module.exports = __webpack_public_path__ + "media/images/city/026-holstentor-854d1e2b1e294fbbb769463eb644da75.svg";